const getProgressLocalStorageKey = (techSmithId: string, hash: string) => `${techSmithId}:${hash}`;

const getProgress = (techSmithId: string, hash: string) => {
   try {
      const localStorageProgress = window.localStorage.getItem(getProgressLocalStorageKey(techSmithId, hash));
      const progress = localStorageProgress ? parseFloat(localStorageProgress) : 0;
      return isNaN(progress) ? 0 : progress;
   } catch {
      // Local storage not supported
   }
   return 0;
};

const setProgress = (techSmithId: string, hash: string, progress: string) => {
   try {
      window.localStorage.setItem(getProgressLocalStorageKey(techSmithId, hash), progress);
   } catch {
      // Local storage not supported
   }
};

const removeProgress = (techSmithId: string, hash: string) => {
   try {
      window.localStorage.removeItem(getProgressLocalStorageKey(techSmithId, hash));
   } catch {
      // Local storage not supported
   }
};

export default
{
   getProgress,
   setProgress,
   removeProgress
};
